import SignupForm from './SignupForm'
import defaultSchema from './schemas/defaultSchema'
import ReactDatePicker from './fields/ReactDatePicker'
import HTMLDateInput from './fields/HTMLDateInput'
import { browserSupportsDateInput } from './utils'

// Note, React and ReactDOM must be supplied globally

// If we want to use this logic outside of UMD, we could create a wrapper
// component and then just load that from either place.

// Some stories in SignupForm.stories.js duplicate some of the logic here,
// so yeah, that wrapper component would be nice.

export default {
  attach(domElement, options) {
    const {
      hideLists = false,
      hidePreferences = false,
      includePhone = false,
      includeBirthday = false,
      adjustSchemas = ({ jsonSchema, uiSchema }) => {
        return { jsonSchema, uiSchema }
      },
    } = options
    let formData = {}
    if (options.formData) {
      formData = { ...options.formData }
    }
    let jsonSchema = {
      ...defaultSchema.jsonSchema,
    }
    let uiSchema = {
      ...defaultSchema.uiSchema,
    }
    if (options.uiSchema) {
      uiSchema = { ...options.uiSchema }
    }
    if (hideLists) {
      const keys = Object.keys(defaultSchema.jsonSchema.properties)
      uiSchema = keys
        .filter(key => key.indexOf('list_') === 0)
        .reduce((uiSchema, key) => {
          uiSchema[key] = { 'ui:widget': 'hidden' }
          return uiSchema
        }, uiSchema)
    }
    if (hidePreferences) {
      uiSchema.preferences = {
        'ui:widget': 'checkboxes',
        classNames: 'cid-signup-form-group cid-signup-form-group-hidden',
      }
    }
    if (includePhone) {
      jsonSchema.properties.phone = {
        type: 'string',
        title: 'Phone',
      }
      uiSchema.phone = {
        'ui:widget': 'text',
        'ui:options': {
          inputType: 'tel',
        },
        classNames: 'cid-signup-form-group',
      }
    }
    if (includeBirthday) {
      jsonSchema.properties.birth_date = {
        type: 'string',
        title: 'Birthday',
      }
      if (browserSupportsDateInput()) {
        uiSchema.birth_date = {
          'ui:widget': 'html-date',
          classNames: 'cid-signup-form-group',
          'ui:options': {
            min: new Date(1910, 0, 1).toISOString().slice(0, 10),
            max: new Date().toISOString().slice(0, 10),
          },
        }
      } else {
        uiSchema.birth_date = {
          'ui:field': 'rdp',
          classNames: 'cid-signup-form-group',
          'ui:options': {
            maxYear: new Date().getFullYear(),
          },
        }
      }
    }
    const schemaUpdateResult = adjustSchemas({ jsonSchema, uiSchema })
    jsonSchema = schemaUpdateResult.jsonSchema
    uiSchema = schemaUpdateResult.uiSchema
    ReactDOM.render(
      <SignupForm
        {...options}
        fields={{ rdp: ReactDatePicker }}
        widgets={{ 'html-date': HTMLDateInput }}
        formData={formData}
        schema={jsonSchema}
        uiSchema={uiSchema}
        hidePreferences={hidePreferences}
      />,
      domElement,
    )
  },
}
